import incomeAndExpenditureScheduleMonthlyLayout from './incomeAndExpenditureScheduleMonthlyLayout';

export default incomeAndExpenditureScheduleMonthlyLayout;